export const nigerianBreeds = [
  { label: "Unknown Breed", breed: "Unknown Breed" },
  { label: "Adamawa Gudali", breed: "Adamawa Gudali" },
  { label: "Azawak", breed: "Azawak" },
  {
    label: "Bunaji (White Fulani)",
    breed: "Bunaji (White Fulani)",
  },
  { label: "Rahaji", breed: "Rahaji" },
  {
    label: "Sokoto Gudali(Bokolo)",
    breed: "Sokoto Gudali(Bokolo)",
  },
  { label: "Kuri", breed: "Kuri" },
  { label: "N'Dama", breed: "N'Dama" },
  { label: "Muturu", breed: "Muturu" },
  { label: "Keteku", breed: "Keteku" },
  { label: "Gyr", breed: "Gyr" },
  { label: "Nelore", breed: "Nelore" },
  { label: "Angus", breed: "Angus" },
  { label: "Senepol", breed: "Senepol" },
  { label: "Brahman", breed: "Brahman" },
  { label: "Guzerá", breed: "Guzerá" },
  { label: "Sindi", breed: "Sindi" },
  { label: "Holstein Freisian", breed: "Holstein Freisian" },
  { label: "Girolando", breed: "Girolando" },
  { label: "Jersey", breed: "Jersey" },
  { label: "Wadara", breed: "Wadara" },
  { label: "Guzerat", breed: "Guzerat" },
];
export const ratios = [
  { label: "Pure", value: "Pure" },
  { label: "1/2", value: "1/2" },
  { label: "1/4", value: "1/4" },
  { label: "3/4", value: "3/4" },
  { label: "5/8", value: "5/8" },
  { label: "7/8", value: "7/8" },
  { label: "15/16", value: "15/16" },
  { label: "1/8", value: "1/8" },
  { label: "1/16", value: "1/16" },
  { label: "9/16", value: "9/16" },
];

export const farmType = [
  { label: "dairy", value: "dairy" },
  { label: "beef", value: "beef" },
  { label: "poultry", value: "poultry" },
];

export const vaccineArray = [
  { label: "None", value: "none" },
  { label: "Brucella", value: "brucella" },
  { label: "CBPP", value: "cbpp" },
  { label: "FMD", value: "fmd" },
  { label: "HSV", value: "hsv" },
  { label: "IBR", value: "ibr" },
  { label: "BVD", value: "bvd" },
  { label: "BRSV", value: "brsv" },
  { label: "PI", value: "PI" },
  { label: "Leptospirosis", value: "leptospirosis" },
  { label: "Black Quarter", value: "black quarter" },
  { label: "Blue tongue", value: "blue tongue" },
  { label: "Anthrax", value: "annthrax" },
];

export const coatColor = [
  {
    label: "BLACK & WHITE",
    coatColor: "Black & White",
  },
  {
    label: "BLACK",
    coatColor: "Black",
  },
  {
    label: "RED",
    coatColor: "Red",
  },
  {
    label: "GRAY",
    coatColor: "Gray",
  },
  {
    label: "WHITE",
    coatColor: "White",
  },
  {
    label: "BROWN",
    coatColor: "Brown",
  },
  {
    label: "ROAN",
    coatColor: "Roan",
  },
  {
    label: "BLONDE",
    coatColor: "Blonde",
  },
  {
    label: "SORREL",
    coatColor: "Sorrel",
  },
  {
    label: "DUN",
    coatColor: "Dun",
  },
  {
    label: "BAY",
    coatColor: "Bay",
  },
  {
    label: "CHESTNUT",
    coatColor: "Chestnut",
  },
  {
    label: "PALOMINO",
    coatColor: "Palomino",
  },
  {
    label: "CREAM",
    coatColor: "Cream",
  },
  {
    label: "GOLD",
    coatColor: "Gold",
  },
  {
    label: "CHAROLAIS",
    coatColor: "Charolais",
  },
];

export const birthConditions = [
  {
    label: "Unknown condition",
    uid: "unknown condition",
    description: "The condition is Unknown",
  },
  {
    label: "Normal",
    uid: "normal",
    description: "A normal, unassisted birth with no complications",
  },
  {
    label: "Assisted",
    uid: "assisted",
    description:
      "A birth that requires human assistance, such as pulling the calf or providing oxygen",
  },
  {
    label: "Cesarean Section (C-Section)",
    uid: "c-section",
    description:
      "A surgical delivery where the calf is born through an incision in the mother's abdomen",
  },
  {
    label: "Difficult",
    uid: "difficult",
    description:
      "A birth that is challenging or prolonged, but does not require surgical intervention",
  },
  {
    label: "Premature",
    uid: "premature",
    description: "A birth that occurs before the expected due date",
  },
  {
    label: "Stillborn",
    uid: "stillborn",
    description: "A birth where the calf is born dead",
  },
  {
    label: "Twins",
    uid: "twins",
    description: "A birth where two calves are born at the same time",
  },
  {
    label: "Breech",
    uid: "breech",
    description:
      "A birth where the calf is born feet-first or in an abnormal position",
  },
  {
    label: "Dystocia",
    uid: "dystocia",
    description:
      "A birth where the calf becomes stuck or has difficulty passing through the birth canal",
  },
  {
    label: "Malpresentation",
    uid: "malpresentation",
    description:
      "A birth where the calf is not in the correct position for delivery",
  },
  {
    label: "Placenta Previa",
    uid: "placenta-previa",
    description:
      "A birth where the placenta partially or completely covers the cervix",
  },
  {
    label: "Placental Abruption",
    uid: "placental-abruption",
    description:
      "A birth where the placenta separates from the uterus before delivery",
  },
  {
    label: "Umbilical Cord Prolapse",
    uid: "umbilical-cord-prolapse",
    description:
      "A birth where the umbilical cord protrudes through the cervix before the calf is born",
  },
  {
    label: "Fetal Distress",
    uid: "fetal-distress",
    description:
      "A birth where the calf is in distress or compromised during delivery",
  },
  {
    label: "Maternal Distress",
    uid: "maternal-distress",
    description:
      "A birth where the mother is in distress or compromised during delivery",
  },
  {
    label: "Prolonged Labor",
    uid: "prolonged-labor",
    description:
      "A birth where labor is prolonged or exceeds the normal duration",
  },
  {
    labelname: "Induced Labor",
    uid: "induced-labor",
    description:
      "A birth where labor is induced or assisted through medical intervention",
  },
  {
    label: "Spontaneous Abortion",
    uid: "spontaneous-abortion",
    description: "A birth where the pregnancy is lost or terminated naturally",
  },
  {
    label: "Elective Abortion",
    uid: "elective-abortion",
    description:
      "A birth where the pregnancy is terminated through medical intervention",
  },
  {
    label: "Congenital Defect",
    uid: "congenital-defect",
    description:
      "A birth where the calf is born with a congenital defect or abnormality",
  },
  {
    label: "Neonatal Death",
    uid: "neonatal-death",
    description:
      "A birth where the calf dies within the first few weeks of life",
  },
];

export const sex = [
  {
    label: "Male",
    sex: "Male",
  },
  {
    label: "Female",
    sex: "Female",
  },
];

export const breedingTypes = [
  {
    label: "Embryo Transfer",
    name: "Embryo Transfer",
  },
  {
    label: "NATURAL",
    name: "Natural",
  },
  {
    label: "INSEMINATION",
    name: "Insemination",
  },
  {
    label: "INBREEDING",
    name: "Inbreeding",
  },
  {
    label: "OUTBREEDING",
    name: "Outbreeding",
  },
  {
    label: "CROSSBREEDING",
    name: "Crossbreeding",
  },
  {
    label: "LINE BREEDING",
    name: "Line Breeding",
  },
  {
    label: "Unknown Breeding",
    name: "Unknown Breeding",
  },
];

export const paternalTypes = [
  {
    label: "Unknown Types",
    value: "Unknown Types",
    description: "The Information is Unknown",
  },
  {
    label: "Purebred",
    value: "Purebred",
    description:
      "A purebred animal is one that has been bred for many generations to retain its genetic purity and characteristics.",
  },
  {
    label: "Crossbred",
    value: "Crossbred",
    description:
      "A crossbred animal is the offspring of two purebred parents from different breeds.",
  },
  {
    label: "Composite",
    value: "Composite",
    description:
      "A composite animal is a mix of different breeds or species that are bred together to create a new population with desirable traits.",
  },
  {
    label: "Synthetic",
    value: "Synthetic",
    description:
      "A synthetic breed is created by crossing multiple breeds and selecting the offspring for desirable traits.",
  },
  {
    label: "Hybrid",
    value: "Hybrid",
    description:
      "A hybrid animal is the offspring of two parents from different genera, species, or breeds.",
  },
];

export const statuses = [
  { label: "Inactive", uid: "inactive" },
  { label: "Active", uid: "active" },
  { label: "Semen", uid: "semen" },
  { label: "Embryo", uid: "embryo" },
  { label: "Unknown Status", uid: "unknown status" },
];

export const phases = [
  {
    label: "phase 1",
    value: "phase1",
  },
  {
    label: "phase2",
    value: "phase2",
  },
  {
    label: "phase3",
    value: "phase3",
  },
];
export const frameSizes = [
  {
    label: "Small Frame",
    value: "Small Frame",
    description: "Less than 42 inches (107 cm) in height at the withers",
  },
  {
    label: "Medium Frame",
    value: "Medium Frame",
    description: "42-46 inches (107-117 cm) in height at the withers",
  },
  {
    label: "Large Frame",
    value: "Large Frame",
    description: "46-50 inches (117-127 cm) in height at the withers",
  },
  {
    label: "Extra Large Frame",
    value: "Extra Large Frame",
    description: "Over 50 inches (127 cm) in height at the withers",
  },
];

export const bullTypes = [
  {
    label: "Dairy Bull",
    value: "Dairy Bull",
  },
  {
    label: "Beef Bull",
    value: "Beef Bull",
  },
];

export const animalTypes = [
  {
    label: "Live Animal",
    value: "Live Animal",
  },
  {
    label: "Embryo",
    value: "Embryo",
  },
  {
    label: "Semen",
    value: "Semen",
  },
];


// green: #008c8fff
// deep green: #015354ff
// yellow: #cfc130ff